<template>
    <div class="template-base">
        <MessageBoxV3 v-show="messageBox_show" ref="refMessageBox" />
        <Header Title="Bay Pricing" :iconPath="'/images/icons/golfer.png'" class="div-header"></Header>
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit"></Button>
            <Button class="x-smaller-button" :buttonModel="btnSave" @on-clicked="saveSettings" v-if="isDirty" />
        </div>
        <div class="select-button-container div-body" style="overflow-y: auto;" v-if="!fetchingData">
            <div style="font-family:Arial,sans-serif; width:80%; max-width:1400px; margin:30px auto; background:#f7f4f0; padding:24px; border-radius:18px; color:#253b2f;">
                <p style="margin:0 0 22px; color:#5f6f66;">
                    Configure durations, then set ball count and price for each player count.
                </p>

                <div class="station-input-container" style="justify-content: flex-start; gap:15px">
                    <span style="margin:auto 0; display:inline-block; width:90px">Location</span>
                    <select class="station-input-item-select" v-model="siteSettingName" @change="getData" :disabled="isDirty">
                        <option v-bind:value="'sitesetting01'">Main</option>
                        <option v-bind:value="'sitesetting02'">{{ locations.find(item => item.siteSetting === "siteSetting02")?.siteName ?? "Alt 2" }}</option>
                        <option v-bind:value="'sitesetting03'">{{ locations.find(item => item.siteSetting === "siteSetting03")?.siteName ?? "Alt 3" }}</option>
                        <option v-bind:value="'sitesetting04'">{{ locations.find(item => item.siteSetting === "siteSetting04")?.siteName ?? "Alt 4" }}</option>
                        <option v-bind:value="'sitesetting05'">{{ locations.find(item => item.siteSetting === "siteSetting05")?.siteName ?? "Alt 5" }}</option>
                        <option v-bind:value="'sitesetting06'">{{ locations.find(item => item.siteSetting === "siteSetting06")?.siteName ?? "Alt 6" }}</option>
                        <option v-bind:value="'sitesetting07'">{{ locations.find(item => item.siteSetting === "siteSetting07")?.siteName ?? "Alt 7" }}</option>
                        <option v-bind:value="'sitesetting08'">{{ locations.find(item => item.siteSetting === "siteSetting08")?.siteName ?? "Alt 8" }}</option>
                        <option v-bind:value="'sitesetting09'">{{ locations.find(item => item.siteSetting === "siteSetting09")?.siteName ?? "Alt 9" }}</option>
                        <option v-bind:value="'sitesetting10'">{{ locations.find(item => item.siteSetting === "siteSetting10")?.siteName ?? "Alt 10" }}</option>
                    </select>
                </div>

                <div class="station-input-container" style="justify-content: flex-start; gap:15px; margin-top:12px">
                    <span style="margin:auto 0; display:inline-block; width:90px">Category</span>
                    <select class="station-input-item-select" v-model="selectedCategoryId" @change="isDirty = true">
                        <option v-for="category in categoryList" :key="category.globalId" :value="category.globalId">{{ category.categoryText }}</option>
                    </select>
                </div>

                <div class="station-input-container" style="justify-content: flex-start; gap:15px; margin-top:12px">
                    <span style="margin:auto 0; display:inline-block; width:90px">Tax Rates</span>
                    <SelectCheckbox :caption="'Tax Rates'" @on-change="onTaxChange" :itemKey="'bay-pricing'" :items="taxItems" class="hotkey-input-item-select"></SelectCheckbox>
                    <input type="checkbox" id="chkBayTaxInclusive" v-model="taxInclusive" @change="isDirty = true" style="margin-left:15px;" />
                    <label for="chkBayTaxInclusive" style="margin:auto 0">Tax Inclusive</label>
                </div>

                <div style="text-align:right; margin-bottom:8px;">
                    <button class="button-link-dark" style="white-space:nowrap; width:auto; margin:0;" @click="clearAllPricing">Clear All Pricing</button>
                </div>

                <div style="overflow:auto; background:white; border-radius:16px; border:1px solid #d9ded8;">
                    <table style="width:100%; border-collapse:collapse;">
                        <thead>
                            <tr style="background:#3c7458; color:white;">
                                <th style="width:20%;padding:14px; text-align:left;">Duration<br />(minutes)</th>
                                <th style="width:20%;padding:14px; text-align:left">1 Player</th>
                                <th style="width:20%;padding:14px; text-align:left">2 Players</th>
                                <th style="width:20%;padding:14px; text-align:left">3 Players</th>
                                <th style="width:20%;padding:14px; text-align:left">4 Players</th>
                            </tr>
                        </thead>

                        <tbody>
                            <!-- ROW 1 -->
                            <tr v-for="(priceModel, index) in pricingModel" :key="priceModel.id">
                                <td style="padding:14px; background:#eef3ee;align-items: flex-end;">
                                    <div style="font-weight:bold; color:#3c7458; margin-bottom:6px;">{{ priceModel.name || durationNames[index] }}</div>
                                    <input v-model="priceModel.duration" @change="isDirty = true" type="number" min="1" class="inrange-input-duration administrator-input-item-numeric" />
                                    <button class="button-link-dark" style="display:block; margin-top:8px; white-space:nowrap; width:auto;" @click="openPricingHelper(priceModel)">Pricing Helper</button>
                                </td>

                                <td v-for="playerModel in priceModel.players" :key="playerModel.id" style="padding:12px;">
                                    <div style="display:grid; gap:8px;">                                        
                                        <div style="display: flex;flex-direction: row;align-items: center;">
                                            <div style="margin: auto 10px; width:100px;">Balls</div>
                                            <input type="number" @change="isDirty = true" class="inrange-input-balls administrator-input-item-numeric" v-model="playerModel.balls"/>
                                        </div>

                                        <div style="display: flex;flex-direction: row;align-items: center;">
                                            <div style="margin: auto 10px; width:100px;">Price</div>
                                            <input type="number" @change="isDirty = true" step="0.01" class="inrange-input-price administrator-input-item-numeric" v-model="playerModel.price"/>
                                        </div>

                                        <div style="display: flex;flex-direction: row;align-items: center;">
                                            <div style="margin: auto 10px; width:100px;">Unlimited Price</div>
                                            <input type="number" @change="isDirty = true" step="0.01" class="inrange-input-price administrator-input-item-numeric" v-model="playerModel.unlimitedPrice"/>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Pricing Helper: fills 1-4 Players for one duration from a starting value that steps
                     up (fixed amount or percentage) per additional player. -->
                <div v-if="helperDuration" class="pricing-helper-backdrop" @click.self="closePricingHelper">
                    <div class="pricing-helper-dialog">
                        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
                            <span style="font-weight:bold; color:#3c7458;">Pricing Helper — {{ helperDuration.name }}</span>
                            <span style="cursor:pointer; font-size:18px; line-height:1;" @click="closePricingHelper">&times;</span>
                        </div>
                        <hr style="margin-bottom:14px;" />
                        <p style="margin:0 0 14px; color:#5f6f66; font-size:13px;">
                            Sets 1-4 Players for this duration: the starting value is used for 1 Player, then each additional player adds the fixed amount or grows by the percentage.
                        </p>

                        <div style="display:flex; align-items:center; gap:8px; margin-bottom:6px; font-size:12px; font-weight:bold; color:#5f6f66;">
                            <span style="width:110px; flex-shrink:0;"></span>
                            <span style="width:80px;">Start</span>
                            <span style="width:110px;">Type</span>
                            <span style="width:70px;">Amount</span>
                        </div>

                        <div style="display:flex; align-items:center; gap:8px; margin-bottom:10px;">
                            <span style="width:110px; flex-shrink:0;">Balls</span>
                            <input type="number" v-model.number="helperForm.balls" class="administrator-input-item-numeric" style="width:80px;" />
                            <select v-model="helperForm.ballsMode" class="station-input-item-select" style="width:110px;">
                                <option value="fixed">Fixed</option>
                                <option value="percent">Percentage</option>
                            </select>
                            <input type="number" v-model.number="helperForm.ballsStep" class="administrator-input-item-numeric" style="width:70px;" />
                        </div>

                        <div style="display:flex; align-items:center; gap:8px; margin-bottom:10px;">
                            <span style="width:110px; flex-shrink:0;">Price</span>
                            <input type="number" step="0.01" v-model.number="helperForm.price" class="administrator-input-item-numeric" style="width:80px;" />
                            <select v-model="helperForm.priceMode" class="station-input-item-select" style="width:110px;">
                                <option value="fixed">Fixed</option>
                                <option value="percent">Percentage</option>
                            </select>
                            <input type="number" step="0.01" v-model.number="helperForm.priceStep" class="administrator-input-item-numeric" style="width:70px;" />
                        </div>

                        <div style="display:flex; align-items:center; gap:8px; margin-bottom:10px;">
                            <span style="width:110px; flex-shrink:0;">Unlimited Price</span>
                            <input type="number" step="0.01" v-model.number="helperForm.unlimitedPrice" class="administrator-input-item-numeric" style="width:80px;" />
                            <select v-model="helperForm.unlimitedPriceMode" class="station-input-item-select" style="width:110px;">
                                <option value="fixed">Fixed</option>
                                <option value="percent">Percentage</option>
                            </select>
                            <input type="number" step="0.01" v-model.number="helperForm.unlimitedPriceStep" class="administrator-input-item-numeric" style="width:70px;" />
                        </div>

                        <div style="display:flex; justify-content:flex-end; gap:16px; margin-top:20px;">
                            <button class="button-link-dark" style="white-space:nowrap; width:auto;" @click="closePricingHelper">Cancel</button>
                            <button class="button-link-dark" style="white-space:nowrap; width:auto;" @click="applyPricingHelper">Set</button>
                        </div>
                    </div>
                </div>

                <div style="margin-top:28px;">
                    <span class="inrange-four-box-title" style="display:block; font-weight:bold; margin-bottom:6px; color:#3c7458;">Bay Price Modifiers</span>
                    <p style="margin:0 0 14px; color:#5f6f66;">
                        Adjust the price for individual bays. Each bay can add or subtract a fixed amount or a percentage.
                    </p>

                    <div style="overflow:auto; background:white; border-radius:16px; border:1px solid #d9ded8;">
                        <table style="width:100%; border-collapse:collapse;">
                            <thead>
                                <tr style="background:#3c7458; color:white;">
                                    <th style="width:20%;padding:14px; text-align:left;">Bay</th>
                                    <th style="width:20%;padding:14px; text-align:left">Amount</th>
                                    <th style="width:20%;padding:14px; text-align:left">Type</th>
                                    <th v-if="canSetBayStatus" style="width:25%;padding:14px; text-align:left">Bay Status</th>
                                    <th style="width:15%;padding:14px; text-align:right">
                                        <button class="button-link-dark" style="color:white; white-space:nowrap; width:auto;" @click="clearBayModifiers">Clear</button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(modifier, index) in bayModifiers" :key="index">
                                    <td style="padding:14px; background:#eef3ee;">
                                        <input type="number" min="1" v-model.number="modifier.bayId" @change="isDirty = true" class="administrator-input-item-numeric" style="width:70px;" />
                                    </td>
                                    <td style="padding:12px;">
                                        <input type="number" step="0.01"
                                            :min="modifier.type === 'fixed' ? -200 : -100"
                                            :max="200"
                                            v-model.number="modifier.amount" @change="onModifierChanged(modifier)" class="administrator-input-item-numeric" style="width:120px;" />
                                    </td>
                                    <td style="padding:12px;">
                                        <select v-model="modifier.type" @change="onModifierChanged(modifier)" class="station-input-item-select" style="width:180px;">
                                            <option value="fixed">Fixed ($)</option>
                                            <option value="percent">Percentage (%)</option>
                                        </select>
                                    </td>
                                    <td v-if="canSetBayStatus" style="padding:12px;">
                                        <!-- Manual override for when a device's webhook report doesn't arrive. Only
                                             shown here at all because a bay-status-capable device is enabled for the
                                             tenant - the server enforces that independently, so this isn't the only guard.
                                             Disabled while isDirty: an unsaved bay row may not exist in the database yet. -->
                                        <div style="display:flex; align-items:center; gap:8px;">
                                            <select v-model.number="modifier.status" class="station-input-item-select" style="width:150px;" :aria-label="'Set Bay ' + modifier.bayId + ' status'">
                                                <option :value="null" disabled>Set status...</option>
                                                <option v-for="option in manualStatusOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                                            </select>
                                            <button class="button-link-dark" style="white-space:nowrap; width:auto;"
                                                :disabled="isDirty"
                                                :title="isDirty ? 'Save your changes before setting bay status' : ''"
                                                @click="setBayStatus(modifier)">Set</button>
                                        </div>
                                    </td>
                                    <td style="padding:12px; text-align:right;">
                                        <button class="button-link-dark" style="white-space:nowrap; width:auto;" @click="copyModifier(modifier)">Copy</button>
                                        <button class="button-link-dark" style="white-space:nowrap; width:auto; margin-left:14px;" v-if="copiedModifier" @click="pasteModifier(modifier)">Paste</button>
                                        <button class="button-link-dark" style="white-space:nowrap; width:auto; margin-left:14px; color:#a33a3a;" @click="removeBayModifier(index)">Remove</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <button class="button-link-dark" style="display:inline-block; margin-top:14px; font-size:14px; white-space:nowrap; width:auto;" @click="addBayModifier">Add Bay</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/views/components/Shared/Header";
import Button from "@/views/components/Shared/Button";
import ButtonModel from "@/common/models/ButtonModel";
import { ref } from "vue";
import { getCurrentInstance, onMounted } from "@vue/runtime-core";
import { onBeforeRouteLeave } from "vue-router";
import PortalUserModel from "@/common/models/PortalUserModel";
import apiBay from "@/api/apiBay";
import apiLocation from "@/api/apiLocation";
import apiCategory from "@/api/apiCategory";
import apiSettings from "@/api/apiSettings";
import apiTax from "@/api/apiTax";
import SelectCheckbox from "@/views/components/Shared/SelectCheckbox";
import SelectCheckboxItem from "@/common/models/SelectCheckboxItem";
import { BayStatusTypes } from "@/common/enums";

export default {
    components: {
        Header,
        Button,
        SelectCheckbox
    },
    setup() {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(false);

        const pricingModel = ref(null);

        // Fixed labels for the four duration tiers, indexed by row (fallback when a model has no name).
        const durationNames = ["Short", "Standard", "Long", "Extended"];

        const isDirty = ref(false);
        const locations = ref([])
        const siteSettingName = ref("sitesetting01")
        const categoryList = ref([])
        const selectedCategoryId = ref("")
        const taxes = ref([])
        const selectedTaxRates = ref([])
        const taxItems = ref([])
        const taxInclusive = ref(false)
        const bayModifiers = ref([])

        // Whether any bay-status-capable device is enabled for this site - only then is a bay's
        // status something to set manually, so the override control is hidden otherwise.
        const canSetBayStatus = ref(false)

        // Selectable statuses for the manual override: Conflicted and NothingToActivate are
        // server-computed states a device itself never reports, so they aren't legitimate manual
        // assertions - deliberately left off this list even though they're valid BayStatusTypes.
        const manualStatusOptions = [
            { value: BayStatusTypes.Available, label: "Available" },
            { value: BayStatusTypes.InUse, label: "In Use" },
            { value: BayStatusTypes.Cleaning, label: "Cleaning" },
            { value: BayStatusTypes.OutOfOrder, label: "Out of Order" },
            { value: BayStatusTypes.Unknown, label: "Unknown" }
        ]

        const setBayStatus = async (modifier) => {
            if (modifier.status === null || modifier.status === undefined) return;
            // A newly-added or otherwise unsaved bay row may not exist in the database yet - the
            // template already disables the control while dirty, this is the same guard for safety.
            if (isDirty.value) return;

            emitter.emit("server-call-start", "Setting status...");
            try {
                await apiBay.setBayStatus(siteSettingName.value, modifier.bayId, modifier.status);
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error setting bay status", err]);
            }
            emitter.emit("server-call-stop");
        };

        // One row per bay, seeded from the location's saved modifiers. globalId identifies the bay
        // itself, so changing the bay number below renumbers that bay instead of replacing it.
        const buildBayModifiers = (bays, saved) => {
            const savedModifiers = saved || [];
            bayModifiers.value = bays.map(bay => {
                const existing = savedModifiers.find(m => m.bayId === bay.bayId);
                return {
                    globalId: bay.globalId,
                    bayId: bay.bayId,
                    // Unknown rather than null: with no status fetched yet, Unknown is the bay's
                    // actual state, not just an unmade selection - the dropdown should show that,
                    // not the "Set status..." placeholder.
                    status: BayStatusTypes.Unknown,
                    amount: existing ? existing.amount : 0,
                    type: existing ? existing.type : "fixed"
                };
            });
        };

        // Guardrails: a fixed amount is capped at +/- 200 (negative subtracts); a percentage
        // is bounded to -100 - 200.
        const onModifierChanged = (modifier) => {
            if (modifier.type === "fixed") {
                modifier.amount = Math.max(-200, Math.min(200, modifier.amount || 0));
            } else {
                modifier.amount = Math.max(-100, Math.min(200, modifier.amount || 0));
            }
            isDirty.value = true;
        };

        const addBayModifier = () => {
            const nextId = bayModifiers.value.length > 0
                ? Math.max(...bayModifiers.value.map(m => m.bayId || 0)) + 1
                : 1;
            // No globalId yet - the server creates the bay and assigns one on save.
            bayModifiers.value.push({ globalId: "", bayId: nextId, status: BayStatusTypes.Unknown, amount: 0, type: "fixed" });
            isDirty.value = true;
        };

        // Removing a row removes the bay itself on save, along with the devices recorded in it, so
        // confirm first. Removing every row is allowed - it saves the location as having no bays.
        const removeBayModifier = (index) => {
            const modifier = bayModifiers.value[index];
            if (!modifier) return;

            if (!window.confirm(`Remove Bay ${modifier.bayId}? This deletes the bay when you save.`))
                return;

            bayModifiers.value.splice(index, 1);
            isDirty.value = true;
        };

        const clearBayModifiers = () => {
            bayModifiers.value.forEach(modifier => {
                modifier.amount = 0;
                modifier.type = "fixed";
            });
            isDirty.value = true;
        };

        // Zeroes out balls/price/unlimitedPrice for every duration and player count - the
        // durations themselves (name/minutes) are left as-is, only what's charged is cleared.
        const clearAllPricing = () => {
            if (!window.confirm("Clear all pricing and ball information for every duration and player count?"))
                return;

            (pricingModel.value || []).forEach(duration => {
                (duration.players || []).forEach(player => {
                    player.balls = 0;
                    player.price = 0;
                    player.unlimitedPrice = 0;
                });
            });
            isDirty.value = true;
        };

        // Pricing Helper: the duration row currently being filled (null = dialog closed) and the
        // form's starting values + per-additional-player step rule for Balls/Price/UnlimitedPrice.
        const helperDuration = ref(null);
        const defaultHelperForm = () => ({
            balls: 0, ballsMode: "fixed", ballsStep: 0,
            price: 0, priceMode: "fixed", priceStep: 0,
            unlimitedPrice: 0, unlimitedPriceMode: "fixed", unlimitedPriceStep: 0
        });
        const helperForm = ref(defaultHelperForm());

        // Starting values default to this duration's current 1 Player row (id 0) - Type
        // (fixed/percent) and Amount are left as whatever they were last set to, so the same step
        // rule can be reused across durations without re-picking it each time.
        const openPricingHelper = (priceModel) => {
            helperDuration.value = priceModel;
            const firstPlayer = (priceModel.players || []).find(p => p.id === 0);
            helperForm.value.balls = firstPlayer?.balls || 0;
            helperForm.value.price = firstPlayer?.price || 0;
            helperForm.value.unlimitedPrice = firstPlayer?.unlimitedPrice || 0;
        };

        const closePricingHelper = () => {
            helperDuration.value = null;
        };

        // Fixed: add the step amount each time. Percentage: grow by that percent each time.
        const stepHelperValue = (value, mode, amount) =>
            mode === "percent" ? value * (1 + (amount || 0) / 100) : value + (amount || 0);

        // 1 Player gets the starting value; each additional player steps from the previous
        // player's value (not from the starting value) - so a percentage step compounds.
        const applyPricingHelper = () => {
            if (!helperDuration.value) return;

            const players = [...(helperDuration.value.players || [])].sort((a, b) => a.id - b.id);
            let ballsValue = helperForm.value.balls || 0;
            let priceValue = helperForm.value.price || 0;
            let unlimitedValue = helperForm.value.unlimitedPrice || 0;

            players.forEach((player, index) => {
                if (index > 0) {
                    ballsValue = stepHelperValue(ballsValue, helperForm.value.ballsMode, helperForm.value.ballsStep);
                    priceValue = stepHelperValue(priceValue, helperForm.value.priceMode, helperForm.value.priceStep);
                    unlimitedValue = stepHelperValue(unlimitedValue, helperForm.value.unlimitedPriceMode, helperForm.value.unlimitedPriceStep);
                }
                player.balls = Math.round(ballsValue);
                player.price = Math.round(priceValue * 100) / 100;
                player.unlimitedPrice = Math.round(unlimitedValue * 100) / 100;
            });

            isDirty.value = true;
            closePricingHelper();
        };

        const copiedModifier = ref(null);

        const copyModifier = (modifier) => {
            copiedModifier.value = {
                amount: modifier.amount,
                type: modifier.type
            };
        };

        const pasteModifier = (modifier) => {
            if (!copiedModifier.value) return;
            modifier.amount = copiedModifier.value.amount;
            modifier.type = copiedModifier.value.type;
            isDirty.value = true;
        };

        const buildTaxItems = () => {
            taxItems.value = taxes.value.map(tax =>
                new SelectCheckboxItem(tax.taxId, tax.taxName, selectedTaxRates.value.includes(tax.taxId)));
        };

        const onTaxChange = (itemKey, taxId, checked) => {
            if (checked && !selectedTaxRates.value.includes(taxId)) {
                selectedTaxRates.value.push(taxId);
            } else if (!checked) {
                const index = selectedTaxRates.value.indexOf(taxId);
                if (index > -1) selectedTaxRates.value.splice(index, 1);
            }
            isDirty.value = true;
        };

        onMounted(() => {
            getData();
        });
        const portalUser = ref(PortalUserModel.fromToken());

        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";

        const btnSave = ButtonModel.CreateClick("");
        btnSave.iconPath = "/images/icons/save.png"
        btnSave.title = "Save pricing"   

        onBeforeRouteLeave((/*to, from*/) => {
            // check if any components are dirty
            if (isDirty.value) {
                const answer = window.confirm("Do you really want to leave? You have unsaved changes!");
                if (!answer) return false;
            }
        });

        window.onbeforeunload = () => {
            if (isDirty.value) {
                const answer = window.confirm("Do you really want to leave? You have unsaved changes!");
                if (!answer) return false;
            }
        };

        const saveSettings = async () => {
            emitter.emit("server-call-start", "Saving...");
            try {                
                
                await apiBay.savePricing(siteSettingName.value, pricingModel.value, selectedCategoryId.value, selectedTaxRates.value, bayModifiers.value, taxInclusive.value);

                // Re-read the bays so rows that were just added pick up the identity the server
                // assigned them. Without this they would still have no globalId, and saving again
                // would create a second bay instead of updating the one just created.
                const { models: bays } = await apiBay.getBays(siteSettingName.value);
                buildBayModifiers(bays, bayModifiers.value);

                isDirty.value = false;
                
            } catch (err) {
                console.log("ERROR:", err);              
                emitter.emit("show-alert", ["Error saving", err]);
            }
            emitter.emit("server-call-stop");
        }

        const getData = async () => {
            try {
                emitter.emit("server-call-start", "Loading...");
                fetchingData.value = true;

                if (categoryList.value.length == 0)
                    categoryList.value = await apiCategory.getList();
                if (taxes.value.length == 0)
                    taxes.value = await apiTax.getAll();

                const pricing = await apiBay.getPricingSettings(siteSettingName.value);
                pricingModel.value = pricing.models;

                // Default each duration's name (legacy data may not have one) so the label persists on save.
                pricingModel.value?.forEach((model, index) => {
                    if (!model.name) model.name = durationNames[index] ?? model.name;
                });

                // Use the location's saved category, else default to the default category (like everywhere else).
                if (pricing.categoryId) {
                    selectedCategoryId.value = pricing.categoryId;
                } else {
                    const settings = await apiSettings.get();
                    selectedCategoryId.value = settings.defaultCategoryId;
                }

                // The location's saved tax rates.
                selectedTaxRates.value = pricing.taxRates || [];
                taxInclusive.value = pricing.taxInclusive || false;
                buildTaxItems();

                // Bay price modifiers: one row per bay for this location, seeded from saved values.
                // Read from the bay registry (not live status) so each row carries its bay's identity.
                const { models: bays, canSetBayStatus: canSetStatus } = await apiBay.getBays(siteSettingName.value);
                canSetBayStatus.value = canSetStatus;
                buildBayModifiers(bays, pricing.bayModifiers);

                // Seed each row's status dropdown with what's currently reported for that bay, so
                // the control shows the real state instead of always starting blank.
                if (canSetStatus) {
                    const currentStatuses = await apiBay.getBayStatus(siteSettingName.value);
                    bayModifiers.value.forEach(modifier => {
                        const current = currentStatuses.find(s => s.id === modifier.bayId);
                        // Conflicted/NothingToActivate are server-computed, not in the selectable
                        // list - leave those rows on Unknown (the row's seeded default) rather than
                        // showing an option that isn't there.
                        if (current && manualStatusOptions.some(o => o.value === current.status))
                            modifier.status = current.status;
                    });
                }

                if (locations.value.length == 0)
                    locations.value = await apiLocation.getAll();
                        
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };

        return {
            portalUser,
            btnExit,
            btnSave,
            fetchingData,
            pricingModel,
            isDirty,
            saveSettings,
            locations,
            durationNames,
            siteSettingName,
            categoryList,
            selectedCategoryId,
            taxItems,
            onTaxChange,
            taxInclusive,
            bayModifiers,
            clearAllPricing,
            helperDuration,
            helperForm,
            openPricingHelper,
            closePricingHelper,
            applyPricingHelper,
            canSetBayStatus,
            manualStatusOptions,
            setBayStatus,
            addBayModifier,
            removeBayModifier,
            onModifierChanged,
            clearBayModifiers,
            copiedModifier,
            copyModifier,
            pasteModifier,
            getData
        };
    }
};
</script>

<style scoped>
.inrange-input-duration {
    /* width: 70px; */
    padding: 10px;
    border: 1px solid #ccd5cc;
    border-radius: 8px;
}

.inrange-input-price {
    width: 100px;
    padding: 10px;
    border: 1px solid #ccd5cc;
    border-radius: 8px;
    
}

.inrange-input-balls {
    width: 100px;
    padding: 10px;
    border: 1px solid #ccd5cc;
    border-radius: 8px;
}

.pricing-helper-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.pricing-helper-dialog {
    background: white;
    border: 1px solid #d9ded8;
    border-radius: 10px;
    padding: 20px;
    width: 420px;
    max-width: 90vw;
}
</style>
